<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">

                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Pencatatan Piutang</h3>

                            <div class="card-tools">

                                <button type="button" class="btn btn-sm btn-primary"
                                    @click="openFormAddPencatatanUtang()">
                                    <i class="fa fa-plus-square"></i>
                                    Tambah
                                </button>
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <v-data-table :headers="headers" :items="users" :loading="loading"
                                :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                                :server-items-length="totalItems"
                                :footer-props="{ itemsPerPageOptions: [25, 50, 100, 200] }"
                                @update:page="fetchPelanggan" @update:items-per-page="changeItemsPerPage">
                                <template #item.no="{ item, index }">
                                    {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                                </template>
                                <template #item.status="{ item }">
                                    <div class="text-center">
                                        <span :class="`badge badge-${statusLabel(item.status).color}`"
                                            style="padding:8px;font-weight:bold;font-size:12px">
                                            {{ statusLabel(item.status).text }}
                                        </span>
                                    </div>
                                </template>
                                <template #item.amount="{item}">
                                    {{ item.amount | toCurrency }}
                                </template>
                                <template #item.actions="{ item }">
                                    <div style="white-space: nowrap;">
                                        <!-- Jika status 'belum lunas' -->
                                        <template v-if="item.status === 'belum lunas'">
                                            <button class="btn btn-xs btn-warning" title="Update Status Lunas"
                                                @click="openFormBayarUtang(item.id_debts)">
                                                <i class="fas fa-check-square"></i>
                                            </button>

                                            <button class="btn btn-xs btn-danger" title="Hapus Data Utang"
                                                @click="deleteUtang(item.id_debts)">
                                                <i class="fa fa-trash"></i>
                                            </button>

                                            <button class="btn btn-xs btn-secondary" title="Edit Data Utang"
                                                @click="openFormEditUtang(item)">
                                                <i class="far fa-edit"></i>
                                            </button>
                                        </template>

                                        <!-- Jika status 'lunas' -->
                                        <template v-else>
                                            <a class="btn btn-xs btn-primary"  
                                                title="download file bukti pembayaran utang"
                                                v-if="item.bukti_bayar && item.bukti_bayar !== ''"
                                                 :href="'./storage/' + item.bukti_bayar"
                                                >
                                                <i class="fas fa-download text-white"></i>
                                            </a>

                                            <button class="btn btn-xs btn-info" @click="LihatData(item)"
                                                title="Lihat Data Utang">
                                                <i class="fa fa-search text-white"></i>
                                            </button>
                                        </template>
                                    </div>
                                </template>

                            </v-data-table>
                        </div>

                    </div>

                    <!-- /.card -->
                </div>
            </div>


        </div>
    </section>
</template>

<script>
import { EventBus } from '../../../event-bus'
import FormPencatatanUtang from './FormPencatatanUtang.vue'
import FormBayarUtang from './FormBayarUtang.vue'
import { showConfirm } from '../../../helpers/confirm'
export default {

    data() {
        return {
            modal: {
                open: false,
                title: '',
                component: null,
                props: {},
                width: '400px'
            },
            editmode: false,
            users: [],
            kecamatan: [],
            form: new Form({
                id: '',
                nama: '',
                alamat: '',
                email: '',
                hp: '',
                kecamatan_id: '',
            }),
            totalItems: 0,
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 25
            },
            headers: [
                { text: 'No', value: 'no', sortable: false, width: '30px', align: 'center' },
                { text: 'Kategori', value: 'kategori.value', sortable: true, },
                { text: 'Nama', value: 'name', sortable: true, },
                { text: 'Deskrisi', value: 'description', sortable: true, width: '40%' },
                { text: 'Amount', value: 'amount', sortable: true, class: 'text-center' },
                { text: 'Due Date', value: 'due_date', sortable: true, class: 'text-center', },
                { text: 'Status', value: 'status', sortable: true, class: 'text-right', width: '100px' },
                { text: 'Aksi', value: 'actions', sortable: false, class: 'text-center', width: '40px' }
            ]
        }
    },
    mounted() {
        this.fetchPelanggan(),
            EventBus.$on('utang:updated', () => {
                this.fetchPelanggan();
            });
    },
    beforeDestroy() {
        // Bersihkan listener saat komponen dihancurkan
        EventBus.$off('pelanggan:updated');
    },
    methods: {
        async deleteUtang(id) {
            const confirm = await showConfirm({
                title: 'Konfirmasi Hapus',
                text: 'Yakin ingin menghapus data utang ini?',
                confirmButtonText: 'Ya, Hapus',
                cancelButtonText: 'Batal',
            });

            if (confirm.isConfirmed) {
                try {
                    const res = await axios.delete(`api/utang/${id}`);
                    Toast.fire({
                        icon: 'success',
                        title: res.data.message
                    });
                    this.fetchPelanggan();
                } catch (err) {
                    console.error(err);

                }
            }
        },
        statusLabel(status) {
            if (status === 'lunas') {
                return {
                    text: 'Lunas',
                    color: 'success' // hijau
                };
            } else if (status === 'belum lunas') {
                return {
                    text: 'Belum Lunas',
                    color: 'danger' // merah
                };
            } else {
                return {
                    text: 'Tidak Diketahui',
                    color: 'secondary'
                };
            }
        },
        openFormAddPencatatanUtang() {
            EventBus.$emit('modal:show', {
                title: `Form Tambah Data Pencatatan Piutang`,
                component: FormPencatatanUtang,
                props: {},
                width: '700px',
                key: `${Date.now()}`
            })
        },
        openFormBayarUtang(id) {
            EventBus.$emit('modal:show', {
                title: `Form Pembayaran Piutang `,
                component: FormBayarUtang,
                props: { id },
                width: '400px',
                key: `${Date.now()}`
            })
        },
        openFormEditUtang(item) {
            EventBus.$emit('modal:show', {
                title: `Form Edit Data Pencatatan Piutang `,
                component: FormPencatatanUtang,
                props: { editData: item },
                width: '700px',
                key: `${Date.now()}`
            })
        },
        async fetchPelanggan() {
            this.loading = true
            try {
                const res = await axios.get('api/utang/list?type=piutang', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage
                    }
                })

                this.users = res.data.data
                this.totalItems = res.data.total
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchPelanggan()
        },

    }
}
</script>
